import { render, staticRenderFns } from "./pharmaceuticalCare.vue?vue&type=template&id=4a1b8cd6&scoped=true&"
import script from "./pharmaceuticalCare.vue?vue&type=script&lang=js&"
export * from "./pharmaceuticalCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b8cd6",
  null
  
)

export default component.exports